<template>
  <div>
    <!--    BOUNCEBACK-->
    <div
      v-if="allowBonusTypes(BONUS_TYPE.bounceback).includes(BONUS_TYPE.bounceback)"
      class="theme-section-bonuses-description theme-section-bonuses-description--left"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M30 15.38L25.89 12.995C29.85 9.62001 25.875 3.32001 21.12 5.46501L19.815 6.02001L19.65 4.58001C19.5 2.96001 18.66 1.80501 17.55 1.13001C15.09 -0.29949 11.34 0.68001 10.74 4.25001L6.615 1.88001C5.175 1.04001 3.345 1.53501 2.52 2.97501L1.02 5.57001C0.6 6.29001 0.855 7.20501 1.575 7.62501L13.26 14.375L15.51 10.475L18.105 11.975L15.855 15.875L27.54 22.625C28.26 23 29.19 22.79 29.595 22.07L31.095 19.475C31.92 18.035 31.44 16.205 30 15.38ZM15.555 6.50001C14.25 6.87501 13.2 5.48001 13.86 4.32501C14.25 3.60501 15.195 3.36501 15.915 3.77001C17.07 4.44501 16.845 6.18501 15.555 6.50001ZM23.34 11C22.05 11.375 21 9.98001 21.66 8.82501C22.065 8.10501 22.995 7.86501 23.7 8.27001C24.855 8.94501 24.63 10.685 23.34 11ZM28.305 24.32C28.92 24.32 29.505 24.11 30 23.75V29C30 30.665 28.665 32 27 32H3C2.20435 32 1.44129 31.6839 0.87868 31.1213C0.31607 30.5587 0 29.7957 0 29V15.5H12.225L13.5 16.25V29H16.5V17.975L26.805 23.915C27.255 24.185 27.75 24.32 28.305 24.32Z"
          fill="#EAC11D"
        />
      </svg>
      <div>
        <div class="theme-section-bonuses-description__bonus-title">
          {{ _("info-modal.bounceback-title") }}
        </div>
        <div>
          {{ _("info-modal.bounceback-text-1") }}
          <span class="extra-value"> {{ bonusValuePercent(BONUS_TYPE.bounceback) }} %</span>
          <span> {{ _("info-modal.bounceback-text-2") }}.</span>
          {{ _("info-modal.bounceback-text-3") }}.
        </div>
        <div
          v-if="bonusCooldown(BONUS_TYPE.bounceback) && bonusCooldown(BONUS_TYPE.bounceback) !== 0"
          class="modal__bounceback-text"
        >
          <span> {{ _("info-modal.bounceback-text-4") }}</span>
          <span class="extra-value"> {{ bonusCooldown(BONUS_TYPE.bounceback) }}</span>
          <span class="extra-value"> {{ _("hours") }}</span>
        </div>
        <div v-if="bonusDepositRangeIsAvailable(BONUS_TYPE.bounceback)">
          {{ _("info-modal-deposit-available") }}
          <span class="extra-value">{{ bonusDepositRange(BONUS_TYPE.bounceback).minDeposit }}</span>
          {{ _("info-to") }}
          <span class="extra-value"
            >{{ bonusDepositRange(BONUS_TYPE.bounceback).maxDeposit }}
          </span>
          {{ currency }}
        </div>
        <div v-else><br /></div>
      </div>
    </div>
    <!--    CASHBACK-->
    <div
      v-if="allowBonusTypes(BONUS_TYPE.cashback).includes(BONUS_TYPE.cashback) && hasUser"
      class="theme-section-bonuses-description theme-section-bonuses-description--right"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M14.6307 2.29456L14.1111 1.96874C13.0943 1.3453 11.8252 0.983116 10.7342 1.32304C9.56153 1.68819 8.62637 2.59144 8.13653 3.94816L7.43887 3.58894C6.23653 2.96995 5.60715 2.9603 5.08539 3.19484C4.66902 3.38112 4.23485 3.82941 3.74277 4.48401L9.8584 9.21249C10.8158 9.52421 12.2186 9.51679 13.6213 9.15312C15.0314 8.78944 16.4342 8.07694 17.4584 7.11952L19.7666 1.4121C17.733 -0.194735 15.8775 0.735968 14.6307 2.29456ZM18.5717 7.97304C17.31 9.2496 15.4322 10.1105 13.9701 10.4965C13.458 10.6301 12.9459 10.7266 12.4486 10.7785C12.174 11.2312 11.9439 11.6914 11.7658 12.1516C12.1221 13.9625 12.79 15.4469 13.792 16.6641L12.7232 17.5547C12.1072 16.8125 11.558 16.0109 11.1424 15.1203C11.0756 16.8422 11.4615 18.6234 12.0924 20.4789L10.7787 20.9242C9.6209 17.5398 9.22754 14.0738 10.8529 10.8082C10.3037 10.7637 9.78418 10.6598 9.30176 10.4891L9.27949 10.4816C8.96035 10.7859 8.65606 11.1051 8.3666 11.4391C6.02352 14.1555 4.73285 17.7699 5.40824 20.5828C5.76969 22.0894 6.41762 23.5144 7.34981 24.7316C8.71543 24.7019 10.0068 24.7316 11.1795 25.1769C11.7361 25.1176 12.3076 25.0805 12.9014 25.0805C15.0166 25.0805 16.9314 25.4738 18.3787 26.1566C18.9428 26.4238 19.4549 26.743 19.8631 27.1066C19.8631 26.7133 19.9225 26.2902 20.0412 25.9785C19.3807 25.3551 18.965 24.598 18.965 23.7371C18.965 22.5422 19.7592 21.5551 20.9096 20.8426C20.9096 20.5012 20.9764 20.1746 21.0951 19.8629C20.3455 19.2172 19.8631 18.4156 19.8631 17.4805C19.8631 16.8941 20.0561 16.3598 20.3826 15.8773C20.0561 15.4023 19.8631 14.868 19.8631 14.2816C19.8631 13.9922 19.9076 13.725 19.9893 13.4652C19.2693 12.8269 18.8166 12.0402 18.8166 11.1348C18.8166 10.2367 19.2619 9.45741 19.9744 8.82655C19.5365 8.48515 19.0689 8.19569 18.5717 7.97304ZM26.8397 8.14374C24.91 8.14374 23.1658 8.55194 21.9709 9.15312C20.7686 9.75429 20.2045 10.4965 20.2045 11.1348C20.2045 11.7805 20.7686 12.5226 21.9709 13.1238C23.1658 13.725 24.91 14.1332 26.8397 14.1332C27.6783 14.1332 28.4725 14.0516 29.2072 13.918V12.6562C30.2389 12.5004 31.0924 12.2184 31.6416 11.8547V13.1609C32.5693 12.8937 33.46 11.9066 33.4822 11.1348C33.4822 10.4965 32.9182 9.75429 31.7158 9.15312C30.5135 8.55194 28.7768 8.14374 26.8397 8.14374ZM34.0018 13.1684C33.7568 13.4281 33.4674 13.673 33.1408 13.8957L33.1557 16.048C34.0908 15.4914 34.5287 14.8457 34.5287 14.2816C34.5287 13.9254 34.358 13.5394 34.0018 13.1684ZM21.251 14.3113C21.2732 14.9496 21.8373 15.6695 23.0174 16.2633C24.2197 16.8719 25.9564 17.2726 27.8936 17.2726C29.1033 17.2726 30.2389 17.1094 31.2111 16.8422L31.2631 14.8234C29.9865 15.2687 28.4725 15.5137 26.8397 15.5137C24.7244 15.5137 22.8022 15.0906 21.3475 14.3633C21.3104 14.3484 21.2807 14.3262 21.251 14.3113ZM21.3994 16.8941C21.2955 17.0945 21.251 17.2949 21.251 17.4805C21.251 18.1262 21.815 18.8684 23.0174 19.4695C24.2197 20.0707 25.9564 20.4715 27.8936 20.4715C28.8732 20.4715 29.801 20.375 30.6396 20.1894V18.4082C29.7787 18.5715 28.8584 18.6531 27.8936 18.6531C25.7709 18.6531 23.8486 18.2375 22.3939 17.5027C22.0303 17.3246 21.6963 17.1168 21.3994 16.8941ZM34.3803 16.8941C33.9275 17.2133 33.5342 17.4508 33.074 17.6512V19.3062C34.0611 18.7348 34.5287 18.0668 34.5287 17.4805C34.5287 17.2949 34.4842 17.0945 34.3803 16.8941ZM34.9369 19.6254C34.7885 19.7738 34.6252 19.9148 34.4471 20.0559V22.4605C35.2115 21.941 35.5826 21.3695 35.5826 20.85C35.5826 20.4566 35.3674 20.0336 34.9369 19.6254ZM22.3123 20.6644C22.3049 20.7312 22.2975 20.7906 22.2975 20.85C22.2975 21.4957 22.8615 22.2305 24.0639 22.8316C25.2662 23.4402 27.0104 23.841 28.94 23.841C30.0459 23.841 31.0998 23.7074 32.0127 23.4848V21.2656C30.8029 21.6516 29.4002 21.8594 27.8936 21.8594C25.7709 21.8594 23.8486 21.4363 22.3939 20.709C22.3643 20.6941 22.342 20.6793 22.3123 20.6644ZM21.3029 22.2527C20.6572 22.7351 20.3529 23.2621 20.3529 23.7371C20.3529 24.3828 20.917 25.1176 22.1193 25.7262C23.3217 26.3273 25.0584 26.7281 26.9955 26.7281C27.7006 26.7281 28.3834 26.6762 29.0217 26.5797V25.2289H28.94C26.8174 25.2289 24.8951 24.8058 23.4404 24.0711C22.5127 23.6109 21.7408 22.9949 21.3029 22.2527ZM33.3635 24.5238C32.7771 24.7316 32.1389 24.9023 31.4561 25.0137V25.9117C31.5971 25.8523 31.7381 25.793 31.8717 25.7262C32.599 25.3551 33.0889 24.9394 33.3635 24.5238ZM34.0463 25.8746C33.7643 26.1566 33.4377 26.409 33.074 26.6391V28.7617C34.0611 28.1976 34.5287 27.5297 34.5287 26.9433C34.5287 26.6019 34.3729 26.2309 34.0463 25.8746ZM8.16621 26.0824C7.40918 26.0898 6.59278 26.1863 5.74668 26.3867C4.05375 26.7801 2.59832 27.5 1.64832 28.2941C0.698322 29.0809 0.327228 29.8824 0.438556 30.4539C0.549884 31.0254 1.13621 31.5523 2.27918 31.8566C3.41844 32.1535 5.01192 32.1684 6.7041 31.775C7.38692 31.6117 8.0252 31.4039 8.61153 31.159V29.6226C9.69512 29.1402 10.5041 28.5613 10.8678 27.9973V29.8082C11.7658 29.0363 12.1147 28.2644 12.0107 27.7004C11.9068 27.1289 11.3131 26.6019 10.1701 26.3051C9.59863 26.1566 8.91582 26.075 8.16621 26.0824ZM12.9607 26.4683C13.1611 26.7578 13.3021 27.0844 13.3764 27.448C13.458 27.8933 13.4209 28.3238 13.2873 28.7469C14.0221 28.9398 14.69 29.1996 15.2689 29.5262C15.5955 29.7043 15.8998 29.9195 16.167 30.1422C16.835 29.9863 17.399 29.7637 17.7998 29.4965V31.0254C18.9947 30.4613 19.5439 29.7711 19.5439 29.2219C19.5439 28.6652 18.9947 27.975 17.7924 27.4109C16.5975 26.8543 14.8756 26.4758 12.9607 26.4683ZM21.2584 26.8394C21.251 26.8691 21.251 26.9062 21.251 26.9433C21.251 27.5891 21.815 28.3238 23.0174 28.9324C24.2197 29.5336 25.9564 29.9344 27.8936 29.9344C28.8732 29.9344 29.801 29.8305 30.6396 29.6523V27.6558C29.5412 27.9527 28.3018 28.116 26.9955 28.116C24.8729 28.116 22.9506 27.693 21.4959 26.9656C21.4143 26.9211 21.3326 26.8766 21.2584 26.8394ZM21.4662 29.6078C21.3178 29.8527 21.251 30.0902 21.251 30.3203C21.251 30.966 21.815 31.7008 23.0174 32.3094C24.2197 32.9105 25.9564 33.3113 27.8936 33.3113C28.8732 33.3113 29.801 33.2074 30.6396 33.0293V31.0699C29.7787 31.2332 28.8584 31.3223 27.8936 31.3223C25.7709 31.3223 23.8486 30.8992 22.3939 30.1644C22.06 30.0012 21.7482 29.8156 21.4662 29.6078ZM34.3135 29.6078C33.883 29.8973 33.5045 30.1273 33.074 30.3129V32.1387C34.0611 31.5746 34.5287 30.9066 34.5287 30.3203C34.5287 30.0902 34.4619 29.8527 34.3135 29.6078ZM12.5971 30.0086C12.3373 30.3351 12.033 30.6469 11.6916 30.9289C10.5338 31.9012 8.90098 32.6879 7.01582 33.1258C6.3434 33.2816 5.67543 33.3781 5.03418 33.4301C5.27168 33.8234 5.68953 34.2094 6.3011 34.5508C7.3127 35.1223 8.79707 35.5082 10.4447 35.5082C11.1943 35.5082 11.9068 35.4266 12.56 35.2855V33.7418C13.5842 33.5859 14.4451 33.3039 14.9943 32.9402V34.3059C15.7365 33.7863 16.0928 33.2 16.0928 32.6433C16.0928 31.9976 15.6104 31.3074 14.5936 30.7359C14.0443 30.4316 13.3615 30.1793 12.5971 30.0086Z"
          fill="#EAC11D"
        />
      </svg>
      <div>
        <div class="theme-section-bonuses-description__bonus-title">Cashback</div>
        <div class="modal__cashback-text">
          {{ _("info-modal.cashback-text-1") }}
          <span class="extra-value"> {{ bonusValuePercent(BONUS_TYPE.cashback) }} % </span>
          <span>
            {{ _("info-modal.cashback-text-2") }}.

            {{ _("info-modal.cashback-text-3") }}</span
          >

          <span class="extra-value">
            {{
              `${bonusThreshold(BONUS_TYPE.cashback)} ${isSweepstakesEnabled ? "" : currency} `
            }}</span
          >
          <div
            v-if="bonusCooldown(BONUS_TYPE.cashback) && bonusCooldown(BONUS_TYPE.cashback) !== 0"
            class="modal__bounceback-text"
          >
            <span> {{ _("info-modal.bounceback-text-4") }}</span>
            <span class="extra-value"> {{ bonusCooldown(BONUS_TYPE.cashback) }}</span>
            <span class="extra-value"> {{ _("hours") }}</span>
          </div>
          <div v-if="bonusDepositRangeIsAvailable(BONUS_TYPE.cashback)">
            {{ _("info-modal-deposit-available") }}
            <span class="extra-value">{{ bonusDepositRange(BONUS_TYPE.cashback).minDeposit }}</span>
            {{ _("info-to") }}
            <span class="extra-value"
              >{{ bonusDepositRange(BONUS_TYPE.cashback).maxDeposit }}
            </span>
            {{ currency }}
          </div>
          <div v-else><br /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { get } from "lodash-es";

const BONUS_TYPE = {
  cashback: "cashback",
  bounceback: "bounceback",
  lastChance: "lastchance",
};
export default {
  name: "ThemeBonusDescription",
  data() {
    return {
      BONUS_TYPE,
    };
  },
  computed: {
    ...mapGetters({
      balance: "user/balance",
      currency: "user/currency",
      _: "l10n/translate",
      hasUser: "user/hasUser",
      userBonuses: "user/bonuses",
      bonusWagerCoefficient: "user/bonusWagerCoefficient",
    }),
    ...mapState({
      isSweepstakesEnabled: (state) => {
        return get(state, "lobby.params.sweepstakes", false);
      },
    }),
  },
  methods: {
    bonusThreshold(type) {
      const { threshold } = this.userBonuses?.[type] ?? { threshold: 1000 };
      return isNaN(threshold / 100) ? 0 : threshold / 100;
    },

    bonusDepositRange(type) {
      const { minDeposit, maxDeposit } = this.userBonuses?.[type];
      return {
        minDeposit: minDeposit / 100 ?? "-",
        maxDeposit: maxDeposit / 100 ?? "-",
      };
    },

    bonusDepositRangeIsAvailable(type) {
      return (
        this.bonusDepositRange(type)?.minDeposit > 0 && this.bonusDepositRange(type)?.maxDeposit > 0
      );
    },

    bonusValuePercent(type) {
      const { value } = this.userBonuses?.[type] ?? { value: 0 };
      return value ?? 0;
    },
    bonusCooldown(type) {
      return this.userBonuses[type]?.cooldown || 0;
    },
    allowBonusTypes() {
      const bonusesAllow = [];

      if (this.userBonuses?.cashback) {
        bonusesAllow.push(BONUS_TYPE.cashback);
      }

      if (this.userBonuses?.bounceback) {
        bonusesAllow.push(BONUS_TYPE.bounceback);
      }

      if (this.userBonuses?.lastchance) {
        bonusesAllow.push(BONUS_TYPE.lastChance);
      }

      return bonusesAllow;
    },
    hasWager(type) {
      if (this.isSweepstakesEnabled) {
        return false;
      }
      return this.userBonuses[type]?.wager ?? false;
    },
  },
};
</script>
<style lang="scss">
.extra-value {
  color: #d09f29;
  font-weight: 700;
}

.theme-section-bonuses-description {
  content-visibility: hidden;

  svg {
    width: 48px;
    height: 48px;
  }
}
</style>
